import type { Port } from "../blueprint/types.js";
import { isTimerAction } from "./protocol.js";

/** Shared by the editor factories and importable examples. */
export function timerReadPorts(labels: Record<string, string> = {}): Port[] {
  const ports: [string, string][] = [
    ["value", "number"],
    ["unit", "string"],
  ];
  return [
    {
      id: "input1",
      label: labels.reference ?? "Reference",
      direction: "input",
      valueType: "string",
      value: "timer",
    },
    ...ports.map(
      ([id, valueType]): Port => ({
        id,
        label: labels[id] ?? id,
        direction: "output",
        valueType,
      }),
    ),
  ];
}
export function timerActionPorts(
  action: string,
  labels: Record<string, string> = {},
): Port[] {
  if (!isTimerAction(action)) return [];
  const port = (
    id: string,
    valueType: string,
    value: string | number,
  ): Port => ({
    id,
    label: labels[id] ?? id,
    direction: "input",
    valueType,
    value,
  });
  return [
    port("reference", "string", "timer"),
    ...(["timerStart", "timerSet"].includes(action)
      ? [
          port("duration", "number", 5),
          port("unit", "string", "s"),
          ...(action === "timerStart"
            ? [port("mode", "string", "countdown")]
            : []),
        ]
      : []),
  ];
}
